module.exports = __webpack_public_path__ + "static/media/8C.2edc7ccf.svg";